(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["certifications-section"] && !Shopify.designMode) return;
  try {
    
  // Accordion functionality for mobile certifications
  document.addEventListener('DOMContentLoaded', function() {
    const accordionHeaders = document.querySelectorAll('[data-certification-toggle]');
    
    accordionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        
        // Close all other accordions
        accordionHeaders.forEach(otherHeader => {
          if (otherHeader !== this) {
            otherHeader.setAttribute('aria-expanded', 'false');
          }
        });
        
        // Toggle current accordion
        this.setAttribute('aria-expanded', !isExpanded);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
